import { render } from "./Message.vue?vue&type=template&id=41733a6a&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=41733a6a&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41733a6a"]])

export default __exports__